import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import NotAvailable from './notAvailable'
import { parseVideoUrl } from '../../../utils'
import styles from './video.scss'

const cx = classnames.bind(styles)

const Video = ({ videoUrl, className, elmId }) => {
  const parsed = parseVideoUrl(videoUrl)

  if (!parsed) {
    return <NotAvailable text='Video Not Available' />
  }

  return (
    <div className={cx('video-container', className)} data-elm-id={elmId}>
      {parsed.type === 'embed' ? (
        <iframe
          src={parsed.url}
          title='Property Video'
          frameBorder='0'
          allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
          allowFullScreen
          className={cx('video-iframe')}
        />
      ) : (
        <video
          src={parsed.url}
          controls
          autoPlay
          muted
          className={cx('video-iframe')}
          style={{ width: '100%', height: 'auto', objectFit: 'contain' }}
        />
      )}
    </div>
  )
}

Video.propTypes = {
  videoUrl: PropTypes.string.isRequired,
  className: PropTypes.string,
  elmId: PropTypes.string,
}

export default Video
